import React from "react";
import styled from "styled-components";
import { P } from "../";
export const ErrorMessage = ({
  content = "",
  ...props
}) => {
  return React.createElement(ErrorMessageContainer, props, React.createElement(ErrorIcon, {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M9.26.47A1 1 0 008.81 0a1 1 0 00-1.36.47l-7 14a1 1 0 00-.1.45 1 1 0 001 1h14a1.07 1.07 0 00.46-.11 1 1 0 00.45-1.36z",
    transform: "translate(-.36 .09)",
    fill: "#e45c52"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M7 5h2v5H7z"
  }), React.createElement("circle", {
    fill: "#FFF",
    cx: "8",
    cy: "13",
    r: "1"
  })), React.createElement(P, null, content));
};
const ErrorMessageContainer = styled.span`
  align-items: center;
  background-color: ${props => props.theme.colors.inputErrorBg};
  border: 1px solid ${props => props.theme.colors.errorMessageBorder};
  color: ${props => props.theme.colors.errorMessageText};
  display: inline-flex;
  ${props => props.theme.fonts.default}
  margin-bottom: 24px;
  padding: 15px 24px;
`;
const ErrorIcon = styled.svg`
  display: none;
  height: 16px;
  margin-right: 16px;
  position: relative;
  max-width: 16px;
  width: 100%;
  @media only screen and ${props => props.theme.media.large} {
    display: block;
  }
`;